import { Campaign } from '../types/campaign';

export const sampleCampaigns: Campaign[] = [
  {
    id: 'c1',
    name: 'Tech Startup Acquisition Initiative',
    type: 'acquisition',
    status: 'active',
    description: 'Targeting early-stage AI and ML companies for strategic acquisition',
    startDate: '2024-03-01',
    endDate: '2024-08-31',
    budget: 500000,
    criteria: {
      industries: ['Technology', 'Artificial Intelligence', 'Machine Learning'],
      revenueRange: {
        min: 1000000,
        max: 10000000
      },
      employeeRange: {
        min: 10,
        max: 50
      },
      locations: ['San Francisco', 'Boston', 'New York'],
      customCriteria: ['Proprietary Technology', 'Strong IP Portfolio']
    },
    targets: [
      {
        id: 't1',
        companyId: 'comp1',
        campaignId: 'c1',
        status: 'contacted',
        priority: 'high',
        notes: 'Strong AI capabilities, growing revenue',
        outreachHistory: [
          {
            id: 'o1',
            type: 'email',
            date: '2024-03-05',
            description: 'Initial outreach email sent',
            outcome: 'Awaiting response'
          }
        ],
        nextFollowUp: '2024-03-12',
        assignedTo: 'Sarah Johnson'
      }
    ],
    metrics: {
      totalTargets: 25,
      contacted: 15,
      responded: 8,
      meetings: 4,
      declined: 3,
      converted: 1,
      responseRate: 53.33,
      conversionRate: 6.67
    },
    createdAt: '2024-02-15',
    updatedAt: '2024-03-10'
  },
  {
    id: 'c2',
    name: 'Manufacturing Merger Program',
    type: 'merger',
    status: 'active',
    description: 'Identifying potential merger partners in advanced manufacturing',
    startDate: '2024-02-01',
    endDate: '2024-07-31',
    budget: 750000,
    criteria: {
      industries: ['Manufacturing', 'Industrial Automation'],
      revenueRange: {
        min: 5000000,
        max: 50000000
      },
      employeeRange: {
        min: 50,
        max: 250
      },
      locations: ['Detroit', 'Chicago', 'Pittsburgh'],
      customCriteria: ['Advanced Manufacturing Capabilities', 'Industry 4.0 Implementation']
    },
    targets: [
      {
        id: 't2',
        companyId: 'comp2',
        campaignId: 'c2',
        status: 'meeting_scheduled',
        priority: 'high',
        notes: 'Excellent operational synergies',
        outreachHistory: [
          {
            id: 'o2',
            type: 'email',
            date: '2024-02-10',
            description: 'Initial contact',
            outcome: 'Positive response'
          },
          {
            id: 'o3',
            type: 'call',
            date: '2024-02-15',
            description: 'Introductory call',
            outcome: 'Meeting scheduled',
            nextSteps: 'Prepare presentation'
          }
        ],
        nextFollowUp: '2024-03-15',
        assignedTo: 'Michael Chen'
      }
    ],
    metrics: {
      totalTargets: 20,
      contacted: 12,
      responded: 7,
      meetings: 3,
      declined: 2,
      converted: 0,
      responseRate: 58.33,
      conversionRate: 0
    },
    createdAt: '2024-01-15',
    updatedAt: '2024-03-08'
  },
  {
    id: 'c3',
    name: 'Healthcare Portfolio Optimization',
    type: 'divestiture',
    status: 'draft',
    description: 'Strategic divestiture of non-core healthcare assets',
    startDate: '2024-04-01',
    endDate: '2024-09-30',
    budget: 300000,
    criteria: {
      industries: ['Healthcare', 'Medical Devices', 'Healthcare Technology'],
      revenueRange: {
        min: 2000000,
        max: 20000000
      },
      employeeRange: {
        min: 20,
        max: 100
      },
      locations: ['Boston', 'Minneapolis', 'San Diego'],
      customCriteria: ['Strategic Fit', 'Growth Potential']
    },
    targets: [],
    metrics: {
      totalTargets: 0,
      contacted: 0,
      responded: 0,
      meetings: 0,
      declined: 0,
      converted: 0,
      responseRate: 0,
      conversionRate: 0
    },
    createdAt: '2024-03-01',
    updatedAt: '2024-03-01'
  }
];